import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { App } from "./App";
import { AppProviders } from "./AppProviders";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

const app = (
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AppProviders><App/></AppProviders>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);

if (root.hasChildNodes()) hydrateRoot(root, app);
else createRoot(root).render(app);
